// extracted by css-extract-rspack-plugin
export default {"root":"root-XjQOau","closeButton":"closeButton-Q_7RE3"};